import React, { useState } from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { Modal, Button, ButtonGroup } from 'react-bootstrap';
import './Poster.scss';

const Poster = ({ optinData }) => {
	const [show, setShow] = useState(false);
	const [poster, setPoster] = useState({});
	const labels = useLabels();

	if (!optinData) {
		return null;
	}
	const {
		dealerLPPoster: communityPoster,
		dealerLPCustPoster: customerPoster
	} = optinData.optIns;
	const handleClose = () => setShow(false);
	const handleShow = () => {
		if (communityPoster) {
			setPoster({
				img: communityPoster,
				alt: 'LOVE_PROMISE_AWARD_COMMUNITY'
			});
		} else if (customerPoster) {
			setPoster({
				img: customerPoster,
				alt: 'LOVE_PROMISE_AWARD_CUSTOMER'
			});
		}
		setShow(true);
	};

	const handlePoster = (posterName) => {
		if (posterName === 'community' && communityPoster) {
			setPoster({
				img: communityPoster,
				alt: 'LOVE_PROMISE_AWARD_COMMUNITY'
			});
		} else if (posterName === 'customer' && customerPoster) {
			setPoster({
				img: customerPoster,
				alt: 'LOVE_PROMISE_AWARD_CUSTOMER'
			});
		} else {
			setPoster('');
		}
	};

	// Do not render component if no valid poster paths are provided.
	if (!communityPoster && !customerPoster) {
		return null;
	}

	return (
		<React.Fragment>
			<div className="lp-poster">
				<button
					className="poster-display-button row col-xs-12"
					type="button"
					data-toggle="modal"
					onClick={handleShow}
				>
					{communityPoster ? (
						<img
							src={communityPoster}
							alt={labels.get('LOVE_PROMISE_AWARD_COMMUNITY')}
						/>
					) : (
						<img
							src={customerPoster}
							alt={labels.get('LOVE_PROMISE_AWARD_CUSTOMER')}
						/>
					)}
				</button>
				<button
					type="button"
					className="btn btn-default btn-block poster-bottom-button row col-xs-12s"
					onClick={handleShow}
				>
					{labels.get('VIEW_OUR_LOVE_PROMISE_PLEDGE')}
				</button>
			</div>
			<Modal
				dialogClassName="poster-modal"
				show={show}
				onHide={handleClose}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						{labels.get('THE_SUBARU_LOVE_PROMISE')}
					</Modal.Title>
					{customerPoster && communityPoster && (
						<ButtonGroup className="d-flex">
							<Button
								className="poster-modal-button"
								onClick={() => handlePoster('community')}
							>
								{labels.get('COMMUNITY_COMMITMENT')}
							</Button>
							<Button
								className="poster-modal-button"
								onClick={() => handlePoster('customer')}
							>
								{labels.get('CUSTOMER_COMMITMENT')}
							</Button>
						</ButtonGroup>
					)}
				</Modal.Header>
				<Modal.Body>
					<img
						className="img-fluid"
						src={poster.img}
						alt={poster.alt}
					/>
				</Modal.Body>
			</Modal>
		</React.Fragment>
	);
};

const PosterProps = {
	optinData: propTypes.shape({
		optIns: propTypes.shape({
			dealerLPPoster: propTypes.string,
			dealerLPCustPoster: propTypes.string
		})
	}).isRequired
};

Poster.propTypes = PosterProps;

export default Poster;
